import { createStyles, fade, makeStyles, Theme } from '@material-ui/core/styles';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN } from '../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {},
    modal: {
      display: 'flex',
      justifyContent: 'center',
      alightItems: 'center',
    },
    joinNowBlockWrapper: {
      paddingBottom: MIDDLE_MARGIN,
      [theme.breakpoints.up('md')]: {
        paddingBottom: LARGE_MARGIN,
      },
    },
    joinNowBlockContainer: {
      margin: 0,
    },
    startCourseBtn: {
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: 'unset',
      },
    },
    buttonsBlock: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column-reverse',
      marginBottom: 94,
      [theme.breakpoints.up('sm')]: {
        flexDirection: 'row',
      },
    },
    divider: {
      marginLeft: MIDDLE_MARGIN,
      marginRight: MIDDLE_MARGIN,
      width: 1,
      backgroundColor: fade(colorsPalette.white, 0.33),
      height: 40,
      display: 'none',
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    playBtn: {
      marginBottom: MIDDLE_MARGIN,
      width: '100%',
      '&:hover': {
        borderBottomColor: 'transparent',
      },
      [theme.breakpoints.up('sm')]: {
        marginBottom: 0,
        width: 'unset',
      },
    },
    playIcon: {
      width: 24,
      height: 24,
    },
  }),
);

export default useStyles;
